import { useAppDispatch } from "@/shared/lib/redux"
import { IUser } from "@/shared/api/users"
import { 
    openUserBroadcastModal as openUserBroadcastModalAction ,
    closeUserBroadcastModal as closeUserBroadcastModalAction
} from '../../model'

export const useUserBroadcastModal = () => {
    const dispatch = useAppDispatch()

    const openUserBroadcastModal = (user: IUser, onSuccess?: () => void) => {
        dispatch(openUserBroadcastModalAction({
            data: user,
            onSuccess
        }))
    }

    const closeUserBroadcastModal = () => {
        dispatch(closeUserBroadcastModalAction())
    }
    
    return {
        openUserBroadcastModal,
        closeUserBroadcastModal
    }
}

